import { Stack, Typography } from "@mui/material";
import { LocalizationProvider, MultiSectionDigitalClock } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useContext } from "react";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { useFormikContext } from "formik";
import * as Yup from "yup";

export type IScheduleTimeForm = {
  scheduleTime: Date | null;
};

export const scheduleTimeFormInitialValues: IScheduleTimeForm = {
  scheduleTime: null,
};

export const ScheduleTimeFormSchema = Yup.object().shape({
  scheduleTime: Yup.date().nullable().required("Debes seleccionar un horario."),
});

export const scheduleTimeFormFields = Object.keys(scheduleTimeFormInitialValues);

const ScheduleTimeForm = () => {
  const { organization, branch } = useContext(WebsiteContext);
  const formik = useFormikContext<IScheduleTimeForm>();

  const now = new Date();

  const orgBranch = branch?.find((b) => b.id === organization?.mainBranch);

  const currentKeyDay = new Date().toLocaleDateString("en-US", { weekday: "short" }).toLowerCase();

  const openHours = orgBranch?.schedule?.[currentKeyDay]?.openHours?.[0];
  const start = openHours?.start;
  const end = openHours?.end;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" gutterBottom>
          Selecciona un horario
        </Typography>

        <Stack spacing={3} alignItems="center">
          <MultiSectionDigitalClock
            value={formik.values.scheduleTime}
            onChange={(value) => {
              formik.setFieldValue("scheduleTime", value);
            }}
            minTime={start ? new Date(`${now.toISOString().split("T")[0]}T${start}`) : undefined}
            maxTime={end ? new Date(`${now.toISOString().split("T")[0]}T${end}`) : undefined}
            sx={{
              justifyContent: "center",
            }}
          />
        </Stack>
      </Stack>
    </LocalizationProvider>
  );
};

export default ScheduleTimeForm;
